import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=04322b7a"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04322b7a')) {
      api.createRecord('04322b7a', component.options)
    } else {
      api.reload('04322b7a', component.options)
    }
    module.hot.accept("./CompanyInfo.vue?vue&type=template&id=04322b7a", function () {
      api.rerender('04322b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/wizard/CompanyInfo.vue"
export default component.exports